// src/pages/AvailableDoctors.jsx
import React, { useState, useEffect } from "react";

import {
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  CircularProgress,
  Snackbar,
  Alert,
  Chip,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import dayjs from "dayjs";
import { Button } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";

import { API_BASE_URL } from "../../../constant/constant";
import { decrypt } from "../../../components/cryptoUtil";
import { Heading } from "../../componenet/heading";






export default function AvailableDoctors() {
  let decryptedData = {};
  try {
    const tokenData = localStorage.getItem("tokenData");
    decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
  } catch (e) {
    console.warn("Failed to decrypt tokenData", e);
    decryptedData = {};
  }
  const token = localStorage.getItem("token") || "";
  const hospitalId = decryptedData.softsubgroup || "";

  const [doctors, setDoctors] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [assignedDuties, setAssignedDuties] = useState({});

  // Pagination state per Accordion (duty_status)
  const [pageState, setPageState] = useState({});
  const [rowsPerPageState, setRowsPerPageState] = useState({});

  const formatTimeLabel = (t) => {
    if (!t) return "";
    if (typeof t === "string") {
      const parts = t.split(":");
      return parts.length >= 2 ? `${parts[0]}:${parts[1]}` : t;
    }
    return t.format ? t.format("HH:mm") : String(t);
  };

  const fetchDoctors = async (dateStr) => {
    setLoading(true);
    try {
      const res = await fetch(
        `${API_BASE_URL}/api/hospital/available-doctors/${hospitalId}?date=${dateStr}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) throw new Error("Failed to fetch Staff");



      const result = await res.json();


      console.log(result);


      if (result.success && Array.isArray(result.data)) {
        setDoctors(result.data);
      } else {
        setDoctors([]);
        setSnackbar({
          open: true,
          message: "No Staff found",
          severity: "warning",
        });
      }
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: err.message || "Failed to load Staff",
        severity: "error",
      });
      setDoctors([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDoctors(selectedDate.format("YYYY-MM-DD"));
  }, [selectedDate]);

  const filtered = doctors.filter((d) => {
    const q = search.trim().toLowerCase();
    if (!q) return true;
    return (
      (d.doctor_name || "").toLowerCase().includes(q) ||
      (d.specialization || "").toLowerCase().includes(q) ||
      (d.degree || "").toLowerCase().includes(q)
    );
  });

  const getAllDutiesForDoctor = (doc) => {
    const fromServer = Array.isArray(doc.shifts) ? doc.shifts : [];
    const local = Array.isArray(assignedDuties[doc.doctor_id])
      ? assignedDuties[doc.doctor_id]
      : [];
    return [...fromServer, ...local];
  };

  const dutyColor = (type) => {
    if (!type) return "default";
    if (type.toLowerCase().includes("opd")) return "success";
    if (type.toLowerCase().includes("emergency")) return "error";
    if (type.toLowerCase().includes("ipd")) return "warning";
    return "default";
  };

  // Group Staff by duty_status
  // Group Staff by duty_status → job_title
  const groupedDoctors = filtered.reduce((acc, doc) => {
    const duties = getAllDutiesForDoctor(doc);
    const status = duties[0]?.duty_status || "Unassigned";
    const job = doc.staffgroup || "Unknown";

    if (!acc[status]) acc[status] = {};
    if (!acc[status][job]) acc[status][job] = [];
    acc[status][job].push(doc);
    return acc;
  }, {});



  const printSection = (status) => {
    const printContent = document.getElementById(`print-section-${status}`);
    if (!printContent) return;

    const printWindow = window.open("", "_blank", "width=900,height=700");
    printWindow.document.write(`
    <html>
      <head>
        <title>Print - ${status}</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          h2 { color: #1976d2; }
          table { width: 100%; border-collapse: collapse; margin-top: 10px; }
          th, td { border: 1px solid #ccc; padding: 6px; text-align: left; font-size: 13px; }
          th { background: #1976d2; color: white; }
          .job-title { margin-top: 20px; font-weight: bold; font-size: 16px; color: #1976d2; }
        </style>
      </head>
      <body>
        <h2>Staff Availability - ${status}</h2>
        ${printContent.innerHTML}
      </body>
    </html>
  `);
    printWindow.document.close();
    printWindow.print();
  };





  // Initialize page/rowsPerPage for new groups
  useEffect(() => {
    Object.keys(groupedDoctors).forEach((status) => {
      if (pageState[status] === undefined) {
        setPageState((prev) => ({ ...prev, [status]: 0 }));
      }
      if (rowsPerPageState[status] === undefined) {
        setRowsPerPageState((prev) => ({ ...prev, [status]: 10 }));
      }
    });
  }, [groupedDoctors]);

  // Sort status keys: Present first
  const sortedStatuses = Object.keys(groupedDoctors).sort((a, b) => {
    if (a === "Present") return -1;
    if (b === "Present") return 1;
    return a.localeCompare(b);
  });

  return (
    <Card sx={{ mt: 3 }}>
      <CardContent>
        <Heading headingtext="Staff Availability" />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <TextField
              label="Search Staff"
              variant="outlined"
              size="small"
              fullWidth
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <DatePicker
              label="Select Date"
              value={selectedDate}
              onChange={(newDate) => setSelectedDate(newDate || dayjs())}
              slotProps={{ textField: { size: "small" } }}
            />
          </Box>
        </LocalizationProvider>

        {loading ? (
          <CircularProgress />
        ) : (
          <>
            {sortedStatuses.map((status) => {
              const jobGroups = groupedDoctors[status] || {};
              const allDoctors = Object.values(jobGroups).flat(); // merge all job groups into one array
              const page = pageState[status] || 0;
              const rowsPerPage = rowsPerPageState[status] || 10;
              const paginatedDoctors = allDoctors.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              );


              return (
                <Accordion key={status} defaultExpanded sx={{ mb: 1 }}>
                  {/* <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">
          {status} ({allDoctors.length})
        </Typography>
      </AccordionSummary> */}

                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                      <Typography variant="h6">
                        {status} ({Object.values(groupedDoctors[status]).flat().length})
                      </Typography>
                   
                    </Box>
                  </AccordionSummary>

                  <AccordionDetails>
                    {/* ✅ Print button + printable section */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mb: 2,
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<PrintIcon />}
                        onClick={() => printSection(status)}
                      >
                        Print {status}
                      </Button>
                    </Box>

                    {/* ✅ Wrap content in printable container */}
                    <div id={`print-section-${status}`}>
                      {/* Loop by job title inside each duty status */}
                      {Object.entries(jobGroups).map(([staffgroup, doctors]) => (
                        <Box key={staffgroup} sx={{ mb: 3 }}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: "bold",
                              color: "primary.main",
                              mb: 1,
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            {staffgroup} ({doctors.length})
                          </Typography>

                          <Box
                            sx={{
                              maxHeight: 400,
                              overflowY: "auto",
                              mb: 2,
                              border: "1px solid #ccc",
                            }}
                          >
                            <Table>
                              <TableHead>
                                <TableRow sx={{ backgroundColor: "primary.main" }}>
                                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Name</TableCell>
                                 
                                 
                                
                                 
                                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Staff Group</TableCell>
                                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Post Hold</TableCell>
                                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Mobile</TableCell>
                                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Email</TableCell>
                                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Shifts / Duties</TableCell>
                               
                                 <TableCell sx={{ color: "white", fontWeight: "bold" }}>Remarks</TableCell>
                                 
                               
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {doctors.map((doc) => (
                                  <TableRow key={doc.doctor_id}>
                                    <TableCell>{doc.doctor_name}</TableCell>
                                    
                                    <TableCell>{doc.staffgroup}</TableCell>
                                    <TableCell>{doc.post}</TableCell>
                                    <TableCell>{doc.mobile}</TableCell>
                                    <TableCell>{doc.email}</TableCell>
                                    <TableCell>
                                      {getAllDutiesForDoctor(doc).length > 0 ? (
                                        getAllDutiesForDoctor(doc).map((s, i) => (
                                          <Box
                                            key={i}
                                            sx={{
                                              mb: 0.5,
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 1,
                                            }}
                                          >
                                            <Chip
                                              label={`${formatTimeLabel(s.start_time)} - ${formatTimeLabel(
                                                s.end_time
                                              )} ${s.day_of_week ? `(${s.day_of_week})` : ""}`}
                                              size="small"
                                              color={doc.shifts && doc.shifts[i] ? "primary" : "info"}
                                              sx={{ mr: 1 }}
                                            />
                                            {s.duty_type && (
                                              <Chip
                                                label={s.duty_type}
                                                size="small"
                                                color={dutyColor(s.duty_type)}
                                              />
                                            )}
                                          </Box>
                                        ))
                                      ) : (
                                        "No duty assigned"
                                      )}
                                    </TableCell>

                                    <TableCell>{doc.remarks}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Box>
                        </Box>
                      ))}
                    </div>

                    {/* Pagination below printable content */}
                    <TablePagination
                      component="div"
                      count={allDoctors.length}
                      page={page}
                      onPageChange={(e, newPage) =>
                        setPageState((prev) => ({ ...prev, [status]: newPage }))
                      }
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={(e) =>
                        setRowsPerPageState((prev) => ({
                          ...prev,
                          [status]: parseInt(e.target.value, 10),
                        }))
                      }
                      rowsPerPageOptions={[5, 10, 25, 50]}
                    />
                  </AccordionDetails>

                </Accordion>
              );
            })}

            {filtered.length === 0 && (
              <Typography align="center" sx={{ mt: 2 }}>
                No Staff found
              </Typography>
            )}
          </>
        )}

        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </CardContent>
    </Card>
  );
}
